import {
  DisplayFieldsModel,
  OnComplexSettingsModel,
  SiteSettingOptions,
} from "src/app/api/api-types";
import { getApiDetailsDecorator } from "src/utils";

const api = getApiDetailsDecorator<OnComplexSettingsModel>();

export class DriverInformationSettings {
  public constructor(args: ClassProperties<DriverInformationSettings>) {
    this.dropTrailerDriverNumber = args.dropTrailerDriverNumber;
    this.dropTrailerDriverName = args.dropTrailerDriverName;
    this.dropTrailerCDLNumber = args.dropTrailerCDLNumber;
    this.liveTrailerCDLNumber = args.liveTrailerCDLNumber;
    this.liveTrailerDriverName = args.liveTrailerDriverName;
    this.liveTrailerDriverNumber = args.liveTrailerDriverNumber;
  }

  @api({ key: "driverNumber" })
  public readonly dropTrailerDriverNumber: SiteSettingOptions;
  @api({ key: "driverName" })
  public readonly dropTrailerDriverName: SiteSettingOptions;
  @api({ key: "cdlNumber" })
  public readonly dropTrailerCDLNumber: SiteSettingOptions;
  public readonly liveTrailerCDLNumber: SiteSettingOptions;
  public readonly liveTrailerDriverName: SiteSettingOptions;
  public readonly liveTrailerDriverNumber: SiteSettingOptions;

  public static deserialize(
    data: DriverInformationModel,
  ): DriverInformationSettings {
    return new DriverInformationSettings({
      dropTrailerDriverNumber: data.driverNumber,
      dropTrailerDriverName: data.driverName,
      dropTrailerCDLNumber: data.cdlNumber,
      liveTrailerCDLNumber: data.liveTrailerCDLNumber,
      liveTrailerDriverName: data.liveTrailerDriverName,
      liveTrailerDriverNumber: data.liveTrailerDriverNumber,
    });
  }

  public serialize(): DriverInformationModel {
    return {
      cdlNumber: this.dropTrailerCDLNumber,
      driverName: this.dropTrailerDriverName,
      driverNumber: this.dropTrailerDriverNumber,
      liveTrailerCDLNumber: this.liveTrailerCDLNumber,
      liveTrailerDriverName: this.liveTrailerDriverName,
      liveTrailerDriverNumber: this.liveTrailerDriverNumber,
    };
  }
}

type DriverInformationModel = Pick<
  DisplayFieldsModel,
  | "cdlNumber"
  | "driverName"
  | "driverNumber"
  | "liveTrailerCDLNumber"
  | "liveTrailerDriverName"
  | "liveTrailerDriverNumber"
>;
